export default __webpack_public_path__ + "static/media/doctora.c8a7de1c.png";